import React from "react";
import * as RB from "react-bootstrap";

function Detail(props) {
  const handleBackClick = () => {
    const propdata = {
      mode: "orderListing",
      rowData: props?.rowData,
    };
    props.onChange(propdata);
  };

  const { orderDetail } = props;
  const channel = orderDetail?.channel_partner_info || {};
  const retailer = orderDetail?.retailer_info || {};

  const renderField = (label, value) => (
    <div className="mb-2">
      <span className="text-muted small fw-bold text-uppercase">{label}</span>
      <div className="fw-semibold">{value || <>&nbsp;</>}</div>
    </div>
  );

  return (
    <>
      <div className="section-body">
        <RB.Card className="card shadow">
          <RB.Card.Header>
            <h4>Order Detail - {orderDetail?.order_no || ""}</h4>
            <div className="card-header-action">
              <RB.Button
                className="btn btn-primary me-2"
                onClick={handleBackClick}
              >
                Back
              </RB.Button>
            </div>
          </RB.Card.Header>
          <RB.Card.Body>
         
            <RB.Row>
              <RB.Col md={4}>
                {renderField("Order No", orderDetail?.order_no)}
              </RB.Col>
              <RB.Col md={4}>
                {renderField("Order Date", orderDetail?.order_date)}
              </RB.Col>
              <RB.Col md={4}>{renderField("PO No", orderDetail?.po_no)}</RB.Col>
              <RB.Col md={4}>
                {renderField("PO Date", orderDetail?.po_date)}
              </RB.Col>
              <RB.Col md={4}>
                {renderField("Payment Terms", orderDetail?.payment_terms)}
              </RB.Col>
              <RB.Col md={4}>
                {renderField("Transport Mode", orderDetail?.mode_transport)}
              </RB.Col>
              <RB.Col md={12}>
                {renderField("Remarks", orderDetail?.remarks)}
              </RB.Col>
            </RB.Row>

            <h5 className="mt-4 mb-3">Channel Partner & Retailer</h5>
            <hr className="hr-lg mt-1" />

            <RB.Row>
              {/* Channel Partner */}
              <RB.Col md={6}>
                <RB.Card className="mb-3">
                  <RB.Card.Body>
                    <h6 className="mb-3">Channel Partner</h6>
                    <RB.Row>
                      <RB.Col md={6}>
                        {renderField("Company", channel?.companyName)}
                      </RB.Col>
                      <RB.Col md={6}>
                        {renderField("Contact", channel?.contactNo)}
                      </RB.Col>
                      <RB.Col md={6}>
                        {renderField("Email", channel?.authorised_email)}
                      </RB.Col>
                      <RB.Col md={6}>
                        {renderField("Person", channel?.authorised_person_name)}
                      </RB.Col>
                      <RB.Col md={6}>
                        {renderField(
                          "Designation",
                          channel?.authorised_designation
                        )}
                      </RB.Col>
                    </RB.Row>
                  </RB.Card.Body>
                </RB.Card>
              </RB.Col>

              {/* Retailer */}
              <RB.Col md={6}>
                <RB.Card className="mb-3">
                  <RB.Card.Body>
                    <h6 className="mb-3">Retailer</h6>
                    <RB.Row>
                      <RB.Col md={6}>
                        {renderField("Company", retailer?.companyName)}
                      </RB.Col>
                      <RB.Col md={6}>
                        {renderField("Contact", retailer?.contactNo)}
                      </RB.Col>
                      <RB.Col md={6}>
                        {renderField("Email", retailer?.authorised_email)}
                      </RB.Col>
                      <RB.Col md={6}>
                        {renderField(
                          "Person",
                          retailer?.authorised_person_name
                        )}
                      </RB.Col>
                      <RB.Col md={6}>
                        {renderField(
                          "Designation",
                          retailer?.authorised_designation
                        )}
                      </RB.Col>
                    </RB.Row>
                  </RB.Card.Body>
                </RB.Card>
              </RB.Col>
            </RB.Row>

            {/* 🔄 Status Info */}
            <h5 className="mt-4 mb-3">Order Status</h5>
            <hr className="hr-lg mt-1" />
            <RB.Row>
              <RB.Col md={4}>
                {renderField("Status", orderDetail?.status_name)}
              </RB.Col>
              <RB.Col md={4}>
                {renderField("Status Note", orderDetail?.status_note)}
              </RB.Col>
              {/* <RB.Col md={4}>
                {renderField("Status Type", orderDetail?.status_type)}
              </RB.Col> */}
            </RB.Row>

            {/* 📦 Product Items */}
            <h5 className="mt-4 mb-3">Product Items</h5>
            <hr className="hr-lg mt-1" />
            <RB.Table bordered striped responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Category</th>
                  <th>Product</th>
                  <th>Qty</th>
                  {/* <th>Remaining</th> */}
                  {/* <th>Amount</th> */}
                </tr>
              </thead>
              <tbody>
                {orderDetail?.items?.length > 0 ? (
                  orderDetail.items.map((item, idx) => (
                    <tr key={item.id}>
                      <td>{idx + 1}</td>
                      <td>{item.category_name || ""}</td>
                      <td>{item.product_name || ""}</td>
                      <td>{item.qty || ""}</td>
                      {/* <td>{item.remaining_qty || ""}</td> */}
                      {/* <td>{item.amount || "0.00"}</td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No product items found.
                    </td>
                  </tr>
                )}
              </tbody>
            </RB.Table>

            {/* 🧾 Invoices */}
            <h5 className="mt-4 mb-3">Invoices</h5>
            <hr className="hr-lg mt-1" />

            {orderDetail?.invoices?.length > 0 ? (
              orderDetail.invoices.map((inv, idx) => (
                <RB.Card className="mb-4" key={inv.invoice_id}>
                  <RB.Card.Header>
                    <strong>Invoice #{idx + 1}</strong>
                  </RB.Card.Header>

                  <RB.Card.Body>
                    <RB.Row className="mb-3">
                      <RB.Col md={6}>
                        {renderField("Invoice No", inv.invoice_no || "")}
                      </RB.Col>
                      <RB.Col md={6}>
                        {renderField("Date", inv.invoice_date || "")}
                      </RB.Col>
                      <RB.Col md={6}>
                        {renderField(
                          "Total",
                          `₹${inv.invoice_total || "0.00"}`
                        )}
                      </RB.Col>

                      <RB.Col md={6}>
                        {renderField(
                          "Channel Partner",
                          inv.channel_partner || ""
                        )}
                      </RB.Col>
                      <RB.Col md={6}>
                        {renderField(
                          "",
                          inv.invoice_file_url ? (
                            <a
                              href={inv.invoice_file_url}
                              target="_blank"
                              rel="noreferrer"
                            >
                              View Invoice
                            </a>
                          ) : (
                            "-"
                          )
                        )}
                      </RB.Col>
                    </RB.Row>

                    <RB.Table bordered striped responsive className="mb-0">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Product</th>
                          <th>Price</th>
                          <th>Qty</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {inv.invoice_items?.length > 0 ? (
                          inv.invoice_items.map((item, i) => (
                            <tr key={item.id}>
                              <td>{i + 1}</td>
                              <td>{item.product_name || "-"}</td>
                              <td>₹{item.price || "0.00"}</td>
                              <td>{item.qty || "0"}</td>
                              <td>₹{item.amount || "0.00"}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center text-muted">
                              No invoice items found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </RB.Table>
                  </RB.Card.Body>
                </RB.Card>
              ))
            ) : (
              <p className="text-muted">No invoice data found.</p>
            )}
          </RB.Card.Body>
        </RB.Card>
      </div>
    </>
  );
}

export default Detail;
